import { useState } from "react";
import { Link, useLocation } from "react-router-dom";

const Navbar = ({ language, setLanguage }: { language: string; setLanguage: (lang: string) => void }) => {
  const location = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);

  // Optionnel: Ajouter un effet de scroll si vous voulez
  window.addEventListener('scroll', () => {
    if (window.scrollY > 10) {
      setIsScrolled(true);
    } else {
      setIsScrolled(false);
    }
  });

  return (
    <nav className={`bg-gradient-to-r from-gray-800 to-gray-900 text-white p-2 fixed w-full top-0 z-50 transition-all duration-300 ${isScrolled ? 'shadow-lg py-1' : 'py-2'}`}>
      <div className="container mx-auto">
        {/* Contenu principal - une ligne sur grand écran, deux lignes sur petit */}
        <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-3">

          <div className="flex justify-between items-center md:justify-center md:gap-10 ml-5">
            {/* Logo - toujours visible */}
            <Link
              to="/login"
              className="text-2xl font-extrabold text-yellow-500 cursor-pointer hover:text-yellow-600 transition duration-300"
            >
              GMCL
            </Link>

            {/* Séparateur + Langues - visible seulement sur desktop */}
            <div className="hidden md:flex items-center gap-10">
              <div className="h-6 w-px bg-gray-400"></div>
              <div className="flex items-center space-x-2">
                <button
                  onClick={() => setLanguage("fr")}
                  className={`${language === "fr" ? "text-yellow-500 font-bold" : "text-white"} hover:text-yellow-400 transition duration-300 text-sm`}
                >
                  FR
                </button>
                <span className="text-gray-400">|</span>
                <button
                  onClick={() => setLanguage("en")}
                  className={`${language === "en" ? "text-yellow-500 font-bold" : "text-white"} hover:text-yellow-400 transition duration-300 text-sm`}
                >
                  EN
                </button>
              </div>
            </div>

            {/* Langues - visible seulement sur mobile */}
            <div className="flex md:hidden items-center space-x-4 ">
              <button
                onClick={() => setLanguage("fr")}
                className={`${language === "fr" ? "text-yellow-500 font-bold" : "text-white"} hover:text-yellow-400 transition duration-300 text-sm`}
              >
                FR
              </button>
              <span className="text-gray-400 ">|</span>
              <button
                onClick={() => setLanguage("en")}
                className={`${language === "en" ? "text-yellow-500 font-bold" : "text-white"} hover:text-yellow-400 transition duration-300 text-sm mr-10`}
              >
                EN
              </button>
            </div>
          </div>

          {/* Navigation - toujours en ligne unique avec défilement horizontal */}
          <div className="hide-scrollbar w-full flex justify-center">
            <div className="flex space-x-4 text-sm justify-center w-full max-w-md">
              <Link
                to="/"
                className={`flex-1 text-center px-2 py-1 hover:text-yellow-400 transition duration-300 ${location.pathname === "/" ? "text-yellow-500 border-b-2 border-yellow-500" : ""
                  }`}
              >
                {language === "fr" ? "Accueil" : "Home"}
              </Link>
              <Link
                to="/services-mecanique"
                className={`flex-1 text-center px-2 py-1 hover:text-yellow-400 transition duration-300 ${location.pathname === "/services-mecanique" ? "text-yellow-500 border-b-2 border-yellow-500" : ""
                  }`}
              >
                {language === "fr" ? "Mécanique" : "Mechanical"}
              </Link>
              <Link
                to="/services-carrosserie"
                className={`flex-1 text-center px-2 py-1 hover:text-yellow-400 transition duration-300 ${location.pathname === "/services-carrosserie" ? "text-yellow-500 border-b-2 border-yellow-500" : ""
                  }`}
              >
                {language === "fr" ? "Carrosserie" : "Bodywork"}
              </Link>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        .hide-scrollbar::-webkit-scrollbar {
          display: none;
        }
        .hide-scrollbar {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
    </nav>
  );
};

export default Navbar;